import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    input,
    model,
    output,
    ViewEncapsulation
} from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs';
import { createSearchPattern } from 'src/app/shared/utils';

@Component({
  selector: 'app-expr-editor-item-filter-component',
  template: `
    <span class="mr-5 user-select-none">Find:</span>
    <input type="text" class="trg-outline h-28 w-100p" placeholder="Enter Text" [(ngModel)]="value" />

    <button trgButton color="white"
            class="w-28 ml-4 p-relative"
            (click)="hideUnmatched.set(!hideUnmatched())"
            [title]="hideUnmatched() ? 'Show unmatched' : 'Hide unmatched'">
      <i class="{{hideUnmatched() ? 'fas' : 'far'}} fa-filter i-13"></i>
    </button>

    @if (showCollapseButton()) {
      <button trgButton color="white"
              class="w-28 ml-4 toggle-all-btn"
              [class.toggle-all-in]="anyExpanded()"
              (click)="toggleAllClick()"
              [title]="anyExpanded() ? 'Collapse all' : 'Expand all'">
        <i class="fas fa-chevron-double-down i-13"
           [attr.data-expanded]="'' + anyExpanded()"></i>
      </button>
    }
  `,
  styles: [`
    :host {
      display: flex;
      width: 100%;
      flex-direction: row;
      align-items: baseline;
    }

    .toggle-all-btn {
      i {
        transition: transform 0.35s;
        transform: rotateZ(0deg);
      }

      &.toggle-all-in {
        i {
          transform: rotateZ(-179.99deg);
        }
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ExprEditorItemFilterComponent {
  readonly destroyRef = inject(DestroyRef);

  readonly value = model<string>('');
  readonly pattern = output<RegExp[]>();
  readonly hideUnmatched = model<boolean>(false);
  readonly showCollapseButton = input<boolean>(true);
  
  readonly updatePattern = toObservable(this.value).pipe(
    takeUntilDestroyed(this.destroyRef),
    map(x => x.trim()),
    distinctUntilChanged(),
    debounceTime(400),
    map(x => {
      if (x.length)
        return x.split(/\s+/).map(x => createSearchPattern(x, 'i'));
      else
        return null;
    }),
    tap(x => this.pattern.emit(x))
  ).subscribe();

  readonly anyExpanded = input(false);
  readonly toggleAll = output<void>();

  toggleAllClick() {
    this.toggleAll.emit();
  }
}

